import type { StackProps } from '@mantine/core';
import type { ReactNode } from 'react';
import { Stack, Text, Title } from '@mantine/core';

interface PageHeadingProps extends Omit<StackProps, 'title' | 'children'> {
  title: ReactNode;
  subtitle?: ReactNode;
}

export const PageHeading = ({ title, subtitle, style, ...stackProps }: PageHeadingProps) => (
  <Stack gap={4} style={{ minWidth: 0, ...(style as object) }} {...stackProps}>
    <Title order={2} fz={{ base: 22, sm: 24 }} style={{ color: 'var(--color-text-primary)' }}>
      {title}
    </Title>
    {subtitle && (
      <Text fz={{ base: 13, sm: 14 }} style={{ color: 'var(--color-text-secondary)' }}>
        {subtitle}
      </Text>
    )}
  </Stack>
);
